export enum EndpointTypes {
    ApgarCodec = 'APGARCODEC',
    C500 = 'C500',
    Intmtvkit = 'INTMTVKIT',
}
